import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export type UploadButtonProps = ButtonProps & {
  label: string;
  inProgress: boolean;
  onUpload: (file: File) => void;
};

export function UploadButton({ label, inProgress, fullWidth, onUpload, disabled, ...buttonProps }: UploadButtonProps) {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onUpload(files[0]);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files) {
      onUpload(files[0]);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  return (
    <div onDrop={handleDrop} onDragOver={handleDragOver} style={{ width: fullWidth ? '100%' : undefined }}>
      <Button
        component="label"
        fullWidth={fullWidth}
        {...buttonProps}
        disabled={inProgress || disabled}
        startIcon={inProgress ? <CircularProgress /> : <CloudUploadIcon />}
      >
        {label}
        <input type="file" hidden onChange={handleFileChange} />
      </Button>
    </div>
  );
}

export default UploadButton;
